export enum CheckIOType {
    CHECK_IN = "checkin",
    CHECK_OUT = "checkout",
}